// src/services/feature-flags/index.ts
var ACCESS_TIERS = ["all", "public", "research", "admin"];
var ACCESS_TIER_LABEL = {
  all: "Everyone (incl. signed-out)",
  public: "Signed-in users",
  research: "Research tier",
  admin: "Admins only"
};
var FEATURE_REGISTRY = [
  {
    key: "dashboard",
    label: "Dashboard",
    description: "Market overview landing page.",
    route: "/",
    defaultEnabled: true,
    defaultTier: "all",
    serverEnforced: false
  },
  {
    key: "chart",
    label: "Chart",
    description: "Candlestick charts with indicator overlays.",
    route: "/chart",
    defaultEnabled: true,
    defaultTier: "all",
    serverEnforced: false
  },
  {
    key: "sentiment",
    label: "Sentiment",
    description: "Market sentiment scores and signals.",
    route: "/sentiment",
    defaultEnabled: true,
    defaultTier: "all",
    serverEnforced: false
  },
  {
    key: "trading",
    label: "Portfolios",
    description: "Portfolio performance overview (paper + live).",
    route: "/trading",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "automatedTrading",
    label: "Automated Trading",
    description: "Assign strategies to a wallet and tune capital split + risk.",
    route: "/automated",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "liveTrading",
    // REAL-MONEY GLOBAL KILL SWITCH. enabled=true ALLOWS live Kraken orders;
    // enabled=false (the DEFAULT) means strategy-engine refuses every live entry
    // (kill on). This is the operator panic button: flipping it off in the admin
    // panel stops new live risk within seconds (strategy-engine polls flags on a
    // short TTL), without a redeploy. It does NOT auto-flatten — open positions
    // keep their resting SL/TP (preflight §F1: "no new risk, keep protecting").
    label: "Live Trading (REAL MONEY)",
    description: "Master switch for REAL-MONEY order placement on live wallets. OFF by default. Turning it ON allows strategy-engine to place real Kraken orders (still bounded by the per-order max-notional cap and per-wallet dry-run). Turning it OFF is the instant kill switch: new live entries are refused within seconds; existing positions keep their stop-loss/take-profit.",
    route: "/automated",
    // SAFETY: default OFF (killed) so enabling the flag system changes nothing
    // until an admin DELIBERATELY turns real-money trading on. admin-tier only.
    defaultEnabled: false,
    defaultTier: "admin",
    serverEnforced: true
  },
  {
    key: "journal",
    label: "Trade Journal",
    description: "Trade history and journaling.",
    route: "/journal",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "walletCompare",
    label: "Compare Wallets",
    description: "Side-by-side paper-wallet comparison.",
    route: "/wallet-compare",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "wallet",
    label: "Wallet",
    description: "Portfolio positions and management.",
    route: "/wallet",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "strategyBuilder",
    label: "Strategy Builder",
    description: "Compose and configure trading strategies.",
    route: "/strategy",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "backtest",
    label: "Backtest",
    description: "Historical strategy backtesting and replay.",
    route: "/backtest",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  },
  {
    key: "hunt",
    label: "Hunt (Research)",
    description: "Autonomous strategy research. Resource-intensive \u2014 each hunt spawns many harness runs. Disabling this refuses hunt launches server-side.",
    route: "/research",
    defaultEnabled: true,
    defaultTier: "research",
    serverEnforced: true
  },
  {
    key: "apiKeys",
    label: "API Keys",
    description: "Exchange + LLM credential management.",
    route: "/api-keys",
    defaultEnabled: true,
    defaultTier: "public",
    serverEnforced: false
  }
];
var REGISTRY_BY_KEY = Object.fromEntries(
  FEATURE_REGISTRY.map((d) => [d.key, d])
);
function getFeatureDefinition(key) {
  return REGISTRY_BY_KEY[key];
}
var FEATURE_KEYS = FEATURE_REGISTRY.map((d) => d.key);
function defaultFeatureFlags() {
  const out = {};
  for (const def of FEATURE_REGISTRY) {
    out[def.key] = { enabled: def.defaultEnabled, tier: def.defaultTier };
  }
  return out;
}
function resolveFeatureFlag(feature, flags) {
  const def = REGISTRY_BY_KEY[feature];
  const stored = flags?.[feature];
  if (!stored) return { enabled: def.defaultEnabled, tier: def.defaultTier };
  const enabled = typeof stored.enabled === "boolean" ? stored.enabled : def.defaultEnabled;
  const tier = ACCESS_TIERS.includes(stored.tier) ? stored.tier : def.defaultTier;
  return { enabled, tier };
}
function isAdmin(user) {
  return user?.role === "admin";
}
function hasResearchTier(user) {
  return user?.researchTier === "research" || user?.researchTier === "research-trusted";
}
function userMeetsTier(tier, user) {
  switch (tier) {
    case "all":
      return true;
    case "public":
      return user != null;
    case "research":
      return hasResearchTier(user) || isAdmin(user);
    case "admin":
      return isAdmin(user);
    default:
      return false;
  }
}
function isFeatureEnabledForUser(feature, user, flags) {
  const flag = resolveFeatureFlag(feature, flags);
  if (!flag.enabled) return false;
  return userMeetsTier(flag.tier, user);
}

export {
  ACCESS_TIERS,
  ACCESS_TIER_LABEL,
  FEATURE_REGISTRY,
  getFeatureDefinition,
  FEATURE_KEYS,
  defaultFeatureFlags,
  resolveFeatureFlag,
  userMeetsTier,
  isFeatureEnabledForUser
};
//# sourceMappingURL=chunk-MV7DFNEL.js.map